// Can be used to map state keys to labels
// For import export cases
// Warning: Changing this order will also change the order of the fields during parameter export!
export const schema = {

    frequency_MHz: "Fundamental Frequency [MHz]",
    ppp_mpa: "Pressure Amplitude [MPa]",
    pnp_mpa: "Peak Negative Pressure [MPa]",
    isppa: "Isppa [W/cm2]",
    non_derated_MI: "Non-derated MI",
    MI: "MI derated by 0.3 dB/cm/MHz",
    diameter_of_transducer_mm: "Diameter of transducer [mm]",
    focal_depth_mm: "Focal depth [mm]",

    pulse_duration_ms: "Pulse Duration [ms]",
    pulse_ramp_duration_ms: "Ramp Duration [ms]",
    pulse_ramp_shape: "Pulse Ramp Shape",
    duty_cycle_of_pulse: "Duty Cycle of Pulse",

    isSecondLevelTimingParameters: "Pulse Train is enabled",
    pulse_repetition_interval_ms: "Pulse Repetition Interval [ms]",
    pulse_train_duration_ms: "Pulse Train Duration [ms]",
    pulse_train_ramp_duration_ms: "Pulse Train Ramp Duration [ms]",
    pulse_train_ramp_shape: "Pulse Train Ramp Shape",
    duty_cycle_of_pulse_train: "Duty Cycle of PT",

    isThirdLevelTimingParameters: "Pulse Train Repetition is enabled",
    pulse_train_repetition_interval_ms: "Pulse Train Repetition Interval [ms]",
    pulse_train_repetition_duration_ms: "Pulse Train Repetition Duration [ms]",
    pulse_train_repetition_ramp_duration_ms: "Pulse Train Repetition Ramp Duration [ms]",
    pulse_train_repetition_ramp_shape: "Pulse Train Repetition Ramp Shape",
    duty_cycle_of_pulse_train_repetition: "Duty Cycle of PTR",

    TUS_Geometry_Factor_at_Focus: "TUS Geometry Factor at Focus",
    MR_SAR: "MR SAR Averaged over 10 gm or 10 cc [W/kg]",

    isManualExposureTime: "isManualExposureTime",
    overallExposureTimeManual: "Graph Duration",
    tempRiseTimeUnit: "Graph Duration Time Unit",

    electrical_power: "Total Electrical Power [mW]",
    transducer_efficiency: "Transducer efficiency [%]",
    acoustic_power: "Total Acoustic Power [mW]",

    selectedFreeFieldWaterProperties: "Free-Field properties",
    rho_kg_m3_FF: "Density Free-Field [kg/m3]",
    c_m_s_FF: "Speed Of Sound Free-Field [m/s]",

    selectedInSituWaterProperties: "In Situ properties",
    rho_kg_m3_IS: "Density In Situ [kg/m3]",
    c_m_s_IS: "Speed Of Sound In Situ [m/s]",

    coupling_thickness_mm: "Coupling thickness [mm]",
    thickness_of_scalp_mm: "Scalp thickness [mm]",
    thickness_of_skull_mm: "Skull thickness [mm]",

    isManualSkullPressureTransmission: "isManualSkullPressureTransmission",
    skull_pressure_transmission_manual: "Skull pressure transmission [-]",
    isManualBrainPressureTransmission: "isManualBrainPressureTransmission",

    brain_pressure_transmission_manual: "Brain Pressure transmission [-]",
    isManualBrainAttenuationCoeff: "isManualBrainAttenuationCoeff",
    attenuation_coefficient: "Brain attenuation coefficient [db/cm/MHz]",
    absorptionAttenuationCoefficient: "Brain attenuation coefficient for absorption [db/cm/MHz]",
    absorptionFraction: "Brain absorption fraction [-]"
};

export const mappingTable: { [key: string]: string } = {};
Object.entries(schema).forEach(([stateKey, label]) => {
    mappingTable[stateKey] = label;
    mappingTable[label] = stateKey;
});